import { UPDATE_BINARY_STATUS } from '../actions/hyexbinarytunnel';

const initialState = {
  selectedFolder: '',
  pid: '',
  port: '',
  status: 'stopped',
};

export default function hyExBinaryTunnelReducer(
  state = initialState,
  action: any
) {
  switch (action.type) {
    case UPDATE_BINARY_STATUS:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return { ...state };
  }
}
